// https://github.com/moment/moment/issues/3650
// since we are using ts 3.5.1, it should be safe to remove.
export default function interopDefault(m) {
  return m["default"] || m;
}
//# sourceMappingURL=interopDefault.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/_util/interopDefault.js
// module id = 63
// module chunks = 3